module.exports = __webpack_public_path__ + "img/games-23.ce1e1086.jpg";